import i18n from "../../services/store/i18n";
import keys from "./translate/keys";
import translateEN from "./translate/en";
import translateDE from "./translate/de";
import translateRU from "./translate/ru";
import translatePTBR from "./translate/pt-br";
import translateES from "./translate/es";
var resolutionCodes = {
    done: "ResolutionCodesDone",
    incomplete: "ResolutionCodesIncomplete",
    timed_out: "ResolutionCodesTimeOut",
    abandoned: "ResolutionCodesAbandoned",
    ignored: "ResolutionCodesIgnored",
    banned: "ResolutionCodesBanned",
    unsupported: "ResolutionCodesUnsupported",
    opted_out: "ResolutionCodesOptedOut",
    offer_created: "ResolutionCodesOfferCreated",
};
var translateDelimiterStatus = {
    opened: "ConversationLastMessageConversationOpenedBy",
    closed: "ConversationLastMessageConversationClosedBy",
};
export default {
    resolutionCodes: resolutionCodes,
    translateDelimiterStatus: translateDelimiterStatus,
};
function extractTranslations(translations) {
    return Object.keys(translations).map(function (translate) {
        return {
            key: translate,
            value: translations[translate],
        };
    });
}
var InboxConversationKeysTranslate = [
    {
        language: "en",
        phrases: extractTranslations(translateEN),
    },
    {
        language: "de",
        phrases: extractTranslations(translateDE),
    },
    {
        language: "ru",
        phrases: extractTranslations(translateRU),
    },
    {
        language: "pt",
        phrases: extractTranslations(translatePTBR),
    },
    {
        language: "es",
        phrases: extractTranslations(translateES),
    },
];
i18n.addTranslation(InboxConversationKeysTranslate);
export { i18n };
export var k = keys;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLElBQTJCLE1BQU0sMkJBQTJCLENBQUM7QUFDcEUsT0FBTyxJQUFJLE1BQU0sa0JBQWtCLENBQUM7QUFDcEMsT0FBTyxXQUFXLE1BQU0sZ0JBQWdCLENBQUM7QUFDekMsT0FBTyxXQUFXLE1BQU0sZ0JBQWdCLENBQUM7QUFDekMsT0FBTyxXQUFXLE1BQU0sZ0JBQWdCLENBQUM7QUFDekMsT0FBTyxhQUFhLE1BQU0sbUJBQW1CLENBQUM7QUFDOUMsT0FBTyxXQUFXLE1BQU0sZ0JBQWdCLENBQUM7QUFFekMsSUFBTSxlQUFlLEdBQUc7SUFDdEIsSUFBSSxFQUFFLHFCQUFxQjtJQUMzQixVQUFVLEVBQUUsMkJBQTJCO0lBQ3ZDLFNBQVMsRUFBRSx3QkFBd0I7SUFDbkMsU0FBUyxFQUFFLDBCQUEwQjtJQUNyQyxPQUFPLEVBQUUsd0JBQXdCO0lBQ2pDLE1BQU0sRUFBRSx1QkFBdUI7SUFDL0IsV0FBVyxFQUFFLDRCQUE0QjtJQUN6QyxTQUFTLEVBQUUseUJBQXlCO0lBQ3BDLGFBQWEsRUFBRSw2QkFBNkI7Q0FDN0MsQ0FBQztBQUVGLElBQU0sd0JBQXdCLEdBQTRCO0lBQ3hELE1BQU0sRUFBRSw2Q0FBNkM7SUFDckQsTUFBTSxFQUFFLDZDQUE2QztDQUN0RCxDQUFDO0FBRUYsZUFBZTtJQUNiLGVBQWUsaUJBQUE7SUFDZix3QkFBd0IsMEJBQUE7Q0FDekIsQ0FBQztBQUVGLFNBQVMsbUJBQW1CLENBQUMsWUFBcUM7SUFDaEUsT0FBTyxNQUFNLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxDQUFDLEdBQUcsQ0FBQyxVQUFDLFNBQVM7UUFDN0MsT0FBTztZQUNMLEdBQUcsRUFBRSxTQUFTO1lBQ2QsS0FBSyxFQUFFLFlBQVksQ0FBQyxTQUFTLENBQUM7U0FDL0IsQ0FBQztJQUNKLENBQUMsQ0FBQyxDQUFDO0FBQ0wsQ0FBQztBQUVELElBQU0sOEJBQThCLEdBQ2xDO0lBQ0U7UUFDRSxRQUFRLEVBQUUsSUFBSTtRQUNkLE9BQU8sRUFBRSxtQkFBbUIsQ0FBQyxXQUFXLENBQUM7S0FDMUM7SUFDRDtRQUNFLFFBQVEsRUFBRSxJQUFJO1FBQ2QsT0FBTyxFQUFFLG1CQUFtQixDQUFDLFdBQVcsQ0FBQztLQUMxQztJQUNEO1FBQ0UsUUFBUSxFQUFFLElBQUk7UUFDZCxPQUFPLEVBQUUsbUJBQW1CLENBQUMsV0FBVyxDQUFDO0tBQzFDO0lBQ0Q7UUFDRSxRQUFRLEVBQUUsSUFBSTtRQUNkLE9BQU8sRUFBRSxtQkFBbUIsQ0FBQyxhQUFhLENBQUM7S0FDNUM7SUFDRDtRQUNFLFFBQVEsRUFBRSxJQUFJO1FBQ2QsT0FBTyxFQUFFLG1CQUFtQixDQUFDLFdBQVcsQ0FBQztLQUMxQztDQUNGLENBQUM7QUFFSixJQUFJLENBQUMsY0FBYyxDQUFDLDhCQUE4QixDQUFDLENBQUM7QUFFcEQsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO0FBQ2hCLE1BQU0sQ0FBQyxJQUFNLENBQUMsR0FBRyxJQUFJLENBQUMifQ==